import { ensureUnit } from '../ensure-unit';
import type { BoxControlValue } from './types';

/**
 * Convert BoxControl value to CSS margin properties
 *
 * @param {BoxControlValue | object} marginValue - Margin value from BoxControl
 * @returns {object} CSS margin properties
 */
export function convertMarginToCSS(
	marginValue: BoxControlValue | object,
): object {
	if ( ! marginValue || typeof marginValue !== 'object' ) {
		return {};
	}

	const margin = marginValue as BoxControlValue;
	const cssProps: { [ key: string ]: string } = {};

	if ( margin.top ) {
		cssProps.marginTop = ensureUnit( margin.top );
	}

	if ( margin.right ) {
		cssProps.marginRight = ensureUnit( margin.right );
	}

	if ( margin.bottom ) {
		cssProps.marginBottom = ensureUnit( margin.bottom );
	}

	if ( margin.left ) {
		cssProps.marginLeft = ensureUnit( margin.left );
	}

	return cssProps;
}
